// Rolldown's node-mode CJS interop ("type": "module") returns module.exports for
// __esModule-flagged packages, so the default import is `{ default: Component }`.
export const interopDefault = <T>(mod: T): T => {
  const wrapped = mod as { default?: T };
  return wrapped.default ?? mod;
};
